import { useCallback, useRef } from 'react';

import { useChatState } from '@/hooks/useSocket/chat/useChatRooms';
import useSocket from '..';
import { useThrottledCallback } from '@/hooks/useThrottledCallback';

const useChatMethods = () => {
  const socket = useSocket();
  const config = useChatState(({ state: { config } }) => config);
  const lastFormat = useRef(null);

  const sendMessage = useCallback((payload?: Record<string, unknown>): void => socket.emit('chat.sendMessage', payload), [socket]);
  const getUsersTyping = useThrottledCallback((payload: { user_id: string; room_id: string }): void => {
    socket.emit('chat.sendUserTyping', payload);
  }, 3000);
  const getHistory = useCallback(
    async (payload?: Record<string, unknown>): Promise<void> => {
      return socket?.emit('chat.getHistory:chat.setHistory', payload, {}, config?.client_retry_interval_milliseconds ?? undefined);
    },
    [socket]
  );
  const getRooms = useCallback(
    async (payload?: any): Promise<void> => {
      lastFormat.current = payload?.format;
      return socket.emit('chat.getMetadata:chat.setMetadata', payload, {}, config?.client_retry_interval_milliseconds ?? undefined);
    },
    [socket]
  );

  return { sendMessage, getUsersTyping, getHistory, getRooms };
};

export default useChatMethods;
